export default "__VITE_ASSET__BpsIY_dQ__"